window.initSwiper = function(callback) {

  if (window.Swiper) {
    callback();
    return;
  }

  const interval = setInterval(() => {
    if (window.Swiper) {
      clearInterval(interval);
      callback();
    }
  }, 50);

};

window.whenLenisReady = (function () {
  let ready = false;
  let queue = [];

  function run(fn) {
    if (typeof fn === 'function') {
      fn(window.lenis);
    }
  }

  function flush() {
    ready = true;
    queue.forEach(run);
    queue.length = 0;
  }

  if (window.lenis) {
    ready = true;
  } else {
    const check = () => {
      if (window.lenis) {
        flush();
      } else {
        requestAnimationFrame(check);
      }
    };
    check();
  }

  return function (callback) {
    if (typeof callback !== 'function') return;

    if (ready) {
      run(callback);
    } else {
      queue.push(callback);  
    }
  }; 
})();

 
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = ""; 
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


// ANNOUNCEMENT BAR
class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    initSwiper(() => {
      this.init();
    });
  }

  init() {
    this.slider = this.querySelector('.announcement_type--slider');
    if (!this.slider) return;

    const autoplayEnabled = this.dataset.autoplay === 'true';
    const autoplaySpeed = Number(this.dataset.speed) || 3000;
    const effect = this.dataset.effect;

    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1,
      spaceBetween: 15,
      speed: 800,
      grabCursor: true,

      navigation: {
        prevEl: this.querySelector('.swiper-button-prev'),
        nextEl: this.querySelector('.swiper-button-next')
      },

      effect: effect,

      autoplay: autoplayEnabled
        ? {
            delay: autoplaySpeed,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,

      loop: autoplayEnabled
    });
  }
}

customElements.define('announcement-bar', AnnouncementBar);


// HEADER
class MainHeader extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.querySelector('.main_header_inner');
    this.block = this.querySelector('.additional_block');
    this.blockLeft = this.querySelector('.additional_block_left');
    this.blockRight = this.querySelector('.additional_block_right');
    this.mainHeader = this.closest('.main-header');
    this.stickyHeader = this.dataset.stickyHeader;

    this.addShadow = this.addShadow.bind(this);
  }

  connectedCallback() {
    if (!this.wrapper) return;

    if (this.blockLeft || this.blockRight || this.block) {
      setTimeout(() => {

        const isLogoLeft = this.wrapper.classList.contains('logo-left');
        const isLogoCenter = this.wrapper.classList.contains('logo-center');
        const isFloating = this.wrapper.classList.contains('floating_enabled');

        if (isFloating && isLogoCenter && this.block) {
          this.block.style.left = '0%';
          this.block.style.opacity = '1';

        } else if (isFloating && isLogoLeft && this.block) {
          this.block.style.right = '0%';
          this.block.style.opacity = '1';

        }
        else if ((isLogoLeft || isLogoCenter) && this.blockLeft && this.blockRight) {
          this.blockLeft.style.opacity = '1';
          this.blockRight.style.opacity = '1';
          this.blockLeft.style.left = '0%';
          this.blockRight.style.right = '0%';
        }

      }, 200);
    }

    if (this.stickyHeader && this.mainHeader) {
      this.mainHeader.classList.add('sticky-header');
    }

    window.addEventListener('scroll', this.addShadow, { passive: true });
  }

  addShadow() {
    if (!this.mainHeader) return;

    if (window.scrollY > 300) { 
      this.mainHeader.classList.add('shadow');
    } else {
      this.mainHeader.classList.remove('shadow');
    }
  }
}

customElements.define('main-header', MainHeader);


// HERO BANNER
class HeroBanner extends HTMLElement {
  constructor() {
    super();
    this.speed = Number(this.dataset.speed) || 80;
    this.direction = this.dataset.direction || "left";
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.inner = this.querySelector(".hero_banner_heading_inner");
    if (!this.inner) return;

    this.init();
    window.addEventListener("resize", this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    this.init();
  }

  init() {
    const contentWidth = this.inner.scrollWidth;
    if (!contentWidth) return;

    const duration = contentWidth / this.speed;

    const distance = -contentWidth; // always negative distance for marquee

    this.inner.style.setProperty("--marquee-distance", `${distance}px`);
    this.inner.style.animationDuration = `${duration}s`;
 
    // Choose the correct animation
    const animationName =
      this.direction === "right" ? "marquee-right" : "marquee-left";

    this.inner.style.animationName = animationName;
  }
}

customElements.define("hero-banner", HeroBanner);


// HERO BANNER IMAGE
class HeroBannerImage extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector('img');
    this.onImageLoad = this.onImageLoad.bind(this);
  }

  connectedCallback() {
    if (!this.image) return;

    if (this.image.complete) {

      this.fadeIn();
    } else {
      this.image.addEventListener('load', this.onImageLoad, { once: true });
    }
  }

  onImageLoad() {
    this.fadeIn();
  }

  fadeIn() {
    setTimeout(() => {
      this.image.style.opacity = '1';
      this.image.style.transform = 'translateY(0)';
    }, 150); 
  }
}

customElements.define('hero-banner-image', HeroBannerImage);

class ProductBlock extends HTMLElement {
  constructor() {
    super();
    this.slideGroups = [];
    this.colorOptions = [...this.querySelectorAll('.color_input')];
    this.mainLink = this.querySelector('[data-main-link]');
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    window.initSwiper(() => {
      this.initImageSliders();
      this.bindColorSwatches();
      this.enableKeyboardVisualFocus();
    });
  }

  /* -----------------------------
    INIT SWIPERS
  ------------------------------ */
  initImageSliders() {
    const sliderContainers = [
      ...this.querySelectorAll('.product_block_img.swiper')
    ];

    if (!sliderContainers.length) return;

    sliderContainers.forEach(container => {
      if (container.swiper) return;

      const nextBtn = container.querySelector('.next-button-product-block');
      const prevBtn = container.querySelector('.prev-button-product-block');

      const swiperInstance = new Swiper(container, {
        speed: 600,
        slidesPerView: 1,
        spaceBetween: 0,
        a11y: false,

        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },

        breakpoints: {
          0: { allowTouchMove: true },
          990: { allowTouchMove: false }
        }
      });

      this.slideGroups.push(swiperInstance);
    });
  }

  /* -----------------------------
    COLOR SWATCH CLICK
  ------------------------------ */
  bindColorSwatches() {
    if (!this.colorOptions.length) return;

    this.colorOptions.forEach(option => {
      option.addEventListener('click', () => {
        const targetImage = option.dataset.variantImage;
        if (!targetImage) return;

        this.slideGroups.forEach(swiper => {
          const index = [...swiper.slides].findIndex(
            slide => slide.dataset.src === targetImage
          );

          if (index !== -1) {
            swiper.slideTo(index);
          }
        });
      });
    });
  }

  enableKeyboardVisualFocus() {
    if (!this.mainLink || !this.colorOptions.length) return;

    this.mainLink.addEventListener('focusin', (e) => {
      if (!e.target.matches(':focus-visible')) return;

      this.colorOptions.forEach(opt => {
        opt.style.visibility = 'visible';
      });
    });
  }

  disconnectedCallback() {
    this.slideGroups.forEach(swiper => {
      if (swiper && typeof swiper.destroy === 'function') {
        swiper.destroy(true, true);
      }
    });

    this.slideGroups = [];
    this._initialized = false;
  }
}

if (!customElements.get('product-block')) {
  customElements.define('product-block', ProductBlock);
}

// COLLECTION LIST
class CollectionList extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {

    initSwiper(() => {
      this.init();
    });

  }

  init() {

    this.slider = this.querySelector('.collection_list_inner');
    this.spacing = parseInt(this.dataset.spacing) || 15;
    this.columns = parseInt(this.dataset.columns) || 4;

    if (!this.slider) return;

    if (this.slider.swiper) {
      this.slider.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(this.slider, {
      slidesPerView: this.columns,
      spaceBetween: this.spacing,
      loop: false,
      speed: 1200,
      grabCursor: true,
      centeredSlides: false,

      allowTouchMove: true,
      simulateTouch: true,

      navigation: {
        prevEl: this.querySelector('.swiper-button-prev'),
        nextEl: this.querySelector('.swiper-button-next'),
      },

      breakpoints: {
        0: {
          slidesPerView: 1,
          centeredSlides: false,
        },
         370: {
          slidesPerView: 1.5,
          centeredSlides: false,
        },
         460: {
          slidesPerView: 2,
          centeredSlides: false,
        },
        768: {
          slidesPerView: 3,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: this.columns,
          centeredSlides: false,
        },
        1200: {
          slidesPerView: this.columns,
        },
      },

      on: {
        init: (swiper) => {
          setBeforePrevAfterNext(swiper);
        },

        slideChangeTransitionStart: (swiper) => {
          setBeforePrevAfterNext(swiper);
        }
      },
    });

  }
}


// Utility function outside the class
function setBeforePrevAfterNext(swiper) {

  if (!swiper) return;

  const prev = swiper.el.querySelector('.swiper-slide-prev');
  const next = swiper.el.querySelector('.swiper-slide-next');

  const duplicatePrev = swiper.el.querySelector('.swiper-slide-duplicate-prev');
  const duplicateNext = swiper.el.querySelector('.swiper-slide-duplicate-next');

  const beforePrev = prev ? prev.previousElementSibling : null;
  const afterNext = next ? next.nextElementSibling : null;

  swiper.el
    .querySelectorAll('.swiper-slide-before-prev')
    .forEach(el => el.classList.remove('swiper-slide-before-prev'));

  swiper.el
    .querySelectorAll('.swiper-slide-after-next')
    .forEach(el => el.classList.remove('swiper-slide-after-next'));

  if (beforePrev) beforePrev.classList.add('swiper-slide-before-prev');
  if (afterNext) afterNext.classList.add('swiper-slide-after-next');

  if (duplicatePrev?.previousElementSibling) {
    duplicatePrev.previousElementSibling.classList.add('swiper-slide-before-prev');
  }

  if (duplicateNext?.nextElementSibling) {
    duplicateNext.nextElementSibling.classList.add('swiper-slide-after-next');
  }

}

customElements.define('collection-list', CollectionList);

// HORIZONTAL SCROLLER
class HorizontalScroller extends HTMLElement {
  constructor() {
    super();
    this.speed = Number(this.dataset.speed) || 60; // px per second
    this.direction = this.dataset.direction || "left";

    this.x = 0;
    this.lastTime = null;
    this.rafId = null;
  }

  connectedCallback() {
    this.track = this.querySelector(".horizontal_scroller_track");
    this.row = this.track?.querySelector(".horizontal_row");
    if (!this.track || !this.row) return;

    this.rowWidth = this.row.scrollWidth;
    this.start();
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.rafId);
  }

  start() {
    this.x = this.direction === "right" ? -this.rowWidth : 0;
    this.lastTime = null;
    this.loop = this.loop.bind(this);
    this.rafId = requestAnimationFrame(this.loop);
  }

  loop(time) {
    if (!this.lastTime) this.lastTime = time;
    const delta = (time - this.lastTime) / 1000; // seconds
    this.lastTime = time;

    const movement = this.speed * delta;
    this.x += this.direction === "right" ? movement : -movement;

    // Seamless wrap
    if (this.direction === "left" && Math.abs(this.x) >= this.rowWidth) {
      this.x += this.rowWidth;
    }

    if (this.direction === "right" && this.x >= 0) {
      this.x -= this.rowWidth;
    } 
 
    this.track.style.transform = `translate3d(${this.x}px, 0, 0)`;
    this.rafId = requestAnimationFrame(this.loop);
  }
} 

customElements.define("horizontal-scroller", HorizontalScroller);

window.addEventListener("scroll", () => {
  document.dispatchEvent(new Event("theme:scroll"));
});

window.addEventListener("resize", () => {
  document.dispatchEvent(new Event("theme:resize"));
});




// FEATURED COLLECTION
class FeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {

    initSwiper(() => {
      this.init();
    });

  }

  init() {

    this.slider = this.querySelector('.featured_collection_inner.slider_enabled');
    if (!this.slider) return;

    this.columns = parseInt(this.dataset.columns) || 4;
    this.spacing = parseInt(this.dataset.spacing) || 15;

    if (this.slider.swiper) {
      this.slider.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(this.slider, {
      slidesPerView: this.columns,
      spaceBetween: this.spacing,
      speed: 800,
      grabCursor: false,

      navigation: {
        prevEl: this.querySelector('.swiper-button-prev'),
        nextEl: this.querySelector('.swiper-button-next')
      },

      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        350: {
          slidesPerView: 1.5,
        },
        450: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 2.5,
        },
        1024: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: this.columns
        },
      }
    });

  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('featured-collection', FeaturedCollection);



// TESTIMONIALS SLIDER
class TestimonialsSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {

    initSwiper(() => {
      this.init();
    });

  }

  init() {

    this.slider = this.querySelector('.swiper');
    if (!this.slider) return;

    if (this.slider.swiper) {
      this.slider.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1.1,
      spaceBetween: 15,
      speed: 800,
      grabCursor: true,

      navigation: {
        prevEl: this.querySelector('.swiper-button-prev'),
        nextEl: this.querySelector('.swiper-button-next')
      },

      breakpoints: {
        750: {
          slidesPerView: 2.5
        },
        1100: {
          slidesPerView: 3.001
        },
        1200: {
          slidesPerView: 4.001
        }
      }
    });

  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('testimonial-slider', TestimonialsSlider);


class CollectionTabSlider extends HTMLElement {
  constructor() {
    super();
    this.swipers = {};
  }

  connectedCallback() {
    this.columns = parseInt(this.dataset.columns) || 4;
    this.initTabs();

    initSwiper(() => {
      // wait till DOM + styles fully ready
      setTimeout(() => {
        this.triggerFirstTab();
      }, 100);
    });
  }

  triggerFirstTab() {
    if (!this.tabButtons || !this.tabButtons.length) return;

    // remove existing active (important)
    this.tabButtons.forEach(btn => btn.classList.remove('is-active'));
    this.panels.forEach(panel => panel.classList.remove('is-active'));

    this.tabButtons[0].click();
  }

  /* -----------------------------
    INIT TABS
  ------------------------------ */
  initTabs() {
    this.tabButtons = this.querySelectorAll('.tab_button');
    this.panels = this.querySelectorAll('.tab_panel');

    if (!this.tabButtons.length || !this.panels.length) return;

    this.tabButtons.forEach((button, index) => {
      button.addEventListener('click', () => this.activateTab(index));
    });
  }

  /* -----------------------------
    INIT SWIPER
  ------------------------------ */
  initSlider(index) {
    const panel = this.panels[index];
    if (!panel) return;

    const swiperEl = panel.querySelector('.swiper');
    if (!swiperEl) return;

    if (this.swipers[index]) return;

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1.3,
      spaceBetween: 15,
      speed: 800,
      grabCursor: true,
      observer: true,
      observeParents: true,

      navigation: {
        prevEl: panel.querySelector('.swiper-button-prev'),
        nextEl: panel.querySelector('.swiper-button-next'),
      },

      breakpoints: {
        750: { slidesPerView: 2.5 },
        1000: { slidesPerView: this.columns }
      }
    });

    this.swipers[index] = swiper;
  }

  /* -----------------------------
    ACTIVATE TAB
  ------------------------------ */
  activateTab(index) {
    if (!this.tabButtons[index] || !this.panels[index]) return;

    this.tabButtons.forEach(btn => btn.classList.remove('is-active'));
    this.panels.forEach(panel => panel.classList.remove('is-active'));

    this.tabButtons[index].classList.add('is-active');
    this.panels[index].classList.add('is-active');

    // init AFTER visible
    setTimeout(() => {
      this.initSlider(index);

      const swiper = this.swipers[index];
      if (swiper) swiper.update();
    }, 50);
  }

  disconnectedCallback() {
    Object.values(this.swipers).forEach(swiper => {
      swiper?.destroy(true, true);
    });
    this.swipers = {};
  }
}

if (!customElements.get('collection-tab')) {
  customElements.define('collection-tab', CollectionTabSlider);
}
  
class ImgGallery extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    initSwiper(() => {
      this.init();
    });
  }

  init() {
    const sliderEnabled = this.dataset.slider === "true";
    const gallery = this.querySelector('.image-gallery_container');

    if (!sliderEnabled || !gallery) return;

    if (gallery.swiper) {
      gallery.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(gallery, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      speed: 800,
      loop: false,

      breakpoints: {
        640: { slidesPerView: 2 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
        1200: { slidesPerView: 4 }
      }
    });

    this.bindHover(gallery);
  }

  bindHover(gallery) {
    gallery.addEventListener('mouseenter', () => {
      if (this.swiper?.autoplay) {
        this.swiper.autoplay.stop();
      }
    });

    gallery.addEventListener('mouseleave', () => {
      if (this.swiper?.autoplay) {
        this.swiper.autoplay.start();
      }
    });
  }
}

customElements.define('img-gallery', ImgGallery);

class TrendingCollection extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    initSwiper(() => {
      this.init();
    });
  }

  init() {
    const slider = this.querySelector('.trending_collection_grid');
    if (!slider) return;

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(slider, {
      slidesPerView: 1.2,
      spaceBetween: 20,
      centeredSlides: true,
      speed: 1200,
      initialSlide: 1,
      loop: false,

      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
 
      breakpoints: {
        767: {
          slidesPerView: 2.5,
          spaceBetween: 30,
        },
      }
    });
  }
}

customElements.define('trending-collection', TrendingCollection);

class ProductStep extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    initSwiper(() => {
      this.init();
    });
  }

  init() {
    const swiperEl = this.querySelector('.product_steps_content_container');
    if (!swiperEl) return;

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(swiperEl, {
      spaceBetween: 30,
      speed: 800,
      effect: 'fade',
      allowTouchMove: false,

      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },

      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true
      },

      on: {
        init: (swiper) => {
          this.updateActiveStep(swiper);
          this.updateButtons(swiper);
        },
        slideChange: (swiper) => {
          this.updateActiveStep(swiper);
          this.updateButtons(swiper);
        }
      }
    });

    this.bindInnerArrows();
  }

  bindInnerArrows() {
    this.querySelectorAll('.step_left_arrow').forEach(btn => {
      btn.addEventListener('click', () => this.swiper.slidePrev());
    });

    this.querySelectorAll('.step_right_arrow').forEach(btn => {
      btn.addEventListener('click', () => this.swiper.slideNext());
    });
  }

  updateActiveStep(swiper) {
    const activeIndex = swiper.activeIndex;

    swiper.slides.forEach((slide, slideIndex) => {
      const numbers = slide.querySelectorAll('.steps_no');

      numbers.forEach((el, i) => {
        if (slideIndex === activeIndex) {
          el.classList.toggle('active', i === activeIndex);
        } else {
          el.classList.remove('active');
        }
      });
    });
  }

  updateButtons(swiper) {
    const prevBtns = this.querySelectorAll('.swiper-button-prev, .step_left_arrow');
    const nextBtns = this.querySelectorAll('.swiper-button-next, .step_right_arrow');

    const isFirst = swiper.isBeginning;
    const isLast = swiper.isEnd;

    prevBtns.forEach(btn => {
      btn.disabled = isFirst;
      btn.classList.toggle('disabled', isFirst);
    });

    nextBtns.forEach(btn => {
      btn.disabled = isLast;
      btn.classList.toggle('disabled', isLast);
    });
  }
}

customElements.define('product-step', ProductStep);

class CustomerInsight extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    initSwiper(() => {
      this.init();
    });
  }

  init() {
    const slider = this.querySelector('.customer-insights-right');
    if (!slider) return;

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 10,
      speed: 800,
      grabCursor: true,
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true
      }
    });
  }
}

customElements.define('customer-insight', CustomerInsight);


class ProductHotspot extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.resizeObserver = null;
  }

  connectedCallback() {
    initSwiper(() => {
      this.init();
    });

    this.initHeightWatcher();
  }

  /* --------------------------
     INIT SWIPER
  -------------------------- */

  init() {
    const slider = this.querySelector('.product_hotspot__content_container');
    if (!slider) return;

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(slider, {
      direction: "horizontal",
      slidesPerView: 1.2,
      spaceBetween: 20,
      speed: 1200,
      centeredSlides: true,
      loop: true,

      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true
      },

      keyboard: {
        enabled: true
      },

      a11y: {
        enabled: true
      },

      breakpoints: {
        640: {
          slidesPerView: 2.2
        },

        1020: {
          slidesPerView: 3,
           direction: "horizontal",
        },

        1200: {
          direction: "vertical",
          slidesPerView: 3,
          centeredSlides: true
        }
      },

      observer: true,
      observeParents: true,

      on: {
        init: () => {
          this.updateActiveDot();
          this.updateSlideAccessibility();
        },

        slideChange: () => {
          this.updateActiveDot();
          this.updateSlideAccessibility();
        }
      }
    });

    this.bindHotspots();
  }

  /* --------------------------
     HOTSPOT CLICK
  -------------------------- */

  bindHotspots() {
    const dots = this.querySelectorAll(
      ".product_hotspot_slider_custom_pagination .ph_dot"
    );

    if (!dots.length) return;

    dots.forEach(dot => {

      dot.addEventListener("click", () => {
        if (!this.swiper) return;

        const target = parseInt(dot.dataset.targetProduct);

        this.swiper.slideToLoop(target);

      });

    });
  }

  /* --------------------------
     UPDATE ACTIVE DOT
  -------------------------- */

  updateActiveDot() {
    if (!this.swiper) return;

    const dots = this.querySelectorAll(
      ".product_hotspot_slider_custom_pagination .ph_dot"
    );

    dots.forEach(dot => dot.classList.remove("active"));

    const index = this.swiper.realIndex;

    if (dots[index]) {
      dots[index].classList.add("active");
    }
  }


  updateSlideAccessibility() {
    if (!this.swiper) return;

    const slides = this.querySelectorAll('.swiper-slide');

    slides.forEach(slide => {

      const focusables = slide.querySelectorAll(
        'a, button, input, select, textarea'
      );

      const isActive = slide.classList.contains('swiper-slide-active');

      slide.setAttribute('aria-hidden', !isActive);

      focusables.forEach(el => {
        el.setAttribute('tabindex', isActive ? '0' : '-1');
      });

    });
  }

  /* ------------------------------
     HEIGHT CALCULATION
  ------------------------------ */

  initHeightWatcher() {
    const banner = this.querySelector('.product_hotspot_banner');
    const wrapper = this.querySelector('.product_hotspot_slider_wrapper');

    if (!banner || !wrapper) return;

    const updateHeight = () => {
      const height = banner.getBoundingClientRect().height;
      wrapper.style.setProperty('--vertical-height', `${height}px`);
    };

    requestAnimationFrame(updateHeight);

    this.resizeObserver = new ResizeObserver(updateHeight);
    this.resizeObserver.observe(banner);

    window.addEventListener('resize', updateHeight);

    const img = banner.querySelector('img');

    if (img) {
      if (img.complete) {
        updateHeight();
      } else {
        img.addEventListener('load', updateHeight);
      }
    }
  }


  disconnectedCallback() {

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }
}

customElements.define('product-hotspot', ProductHotspot);
  
class InstaFeed extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    initSwiper(() => {
      this.init();
    });
  }

  init() {
    this.slider = this.querySelector('.instafeed_inner');
    this.columns = parseInt(this.dataset.columns) || 4;

    if (!this.slider) return;

    if (this.slider.swiper) {
      this.slider.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(this.slider, {
          slidesPerView: this.columns,
          speed: 1500, 
          loop: true,
          spaceBetween: 15,
          autoplay: false,

          freeMode: {
            enabled: true,
            momentum: true
          },

          allowTouchMove: true,
          simulateTouch: true,

          watchSlidesProgress: true,
          watchSlidesVisibility: true,

          breakpoints: {
            0: { slidesPerView: 1.5 },
            350: { slidesPerView: 2 },
            450: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            1024: { slidesPerView: this.columns },
            1200: { slidesPerView: this.columns },
          }
        });

            this.handleFocusFix();
          }

          updateA11y(swiper) {
            swiper.slides.forEach((slide) => {
              const focusables = slide.querySelectorAll(
                'a, button, input, textarea, select, [tabindex]'
              );

              if (!slide.classList.contains('swiper-slide-visible')) {
                slide.setAttribute('aria-hidden', 'true');

                focusables.forEach((el) => {
                  el.setAttribute('tabindex', '-1');
                });
              } else {
                slide.removeAttribute('aria-hidden');

                focusables.forEach((el) => {
                  el.removeAttribute('tabindex');
                });
              }
            });
          }

  /* -----------------------------
    FIX FOCUS JUMP
  ------------------------------ */
  handleFocusFix() {
    this.slider.addEventListener('focusin', (e) => {
      const slide = e.target.closest('.swiper-slide');

      if (!slide) return;

      if (!slide.classList.contains('swiper-slide-visible')) {
        const index = slide.getAttribute('data-swiper-slide-index');

        if (index !== null && this.swiper) {
          this.swiper.slideTo(index);
        }
      }
    });
  }

  setBeforeAfter(swiper) {
    if (!swiper) return;

    const prev = swiper.el.querySelector('.swiper-slide-prev');
    const next = swiper.el.querySelector('.swiper-slide-next');

    const beforePrev = prev ? prev.previousElementSibling : null;
    const afterNext = next ? next.nextElementSibling : null;

    const beforeBeforePrev = beforePrev ? beforePrev.previousElementSibling : null;
    const afterAfterNext = afterNext ? afterNext.nextElementSibling : null;

    swiper.el.querySelectorAll(
      '.swiper-slide-before-prev, .swiper-slide-after-next, .swiper-slide-before-before-prev, .swiper-slide-after-after-next'
    ).forEach((el) => {
      el.classList.remove(
        'swiper-slide-before-prev',
        'swiper-slide-after-next',
        'swiper-slide-before-before-prev',
        'swiper-slide-after-after-next'
      );
    });

    if (beforePrev) beforePrev.classList.add('swiper-slide-before-prev');
    if (afterNext) afterNext.classList.add('swiper-slide-after-next');

    if (beforeBeforePrev) beforeBeforePrev.classList.add('swiper-slide-before-before-prev');
    if (afterAfterNext) afterAfterNext.classList.add('swiper-slide-after-after-next');
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('insta-feed')) {
  customElements.define('insta-feed', InstaFeed);
}

class IconText extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    initSwiper(() => {
      this.init();
    });
  }

  init() {
    const slider = this.querySelector('.icon-text-wrapper');
    if (!slider) return;

    const columns = parseInt(this.dataset.columns) || 3;

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 15,
      speed: 800,
      observer: true, 
      observeParents: true,
       pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true
      },
      breakpoints: {
        0: {
          slidesPerView: 1
        },
        650: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: Math.min(3, columns)
        },
        1200: {
          slidesPerView: columns
        }
      }
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('icon-text')) {
  customElements.define('icon-text', IconText);
}


class FeaturedBlog extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    initSwiper(() => {
      this.init();
    });
  }

  init() {
    const slider = this.querySelector('.featured_blog_post');
    if (!slider) return;

    let columns = slider.dataset.columns;
    if(!columns) {
      columns = 2;
    }

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 10,
      speed: 800,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 16
        },
        350: {
          slidesPerView: 1.5,
          spaceBetween: 16
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 16
        },
        1000: {
          slidesPerView: 2,
          spaceBetween: 16
        },
        1600: {
          slidesPerView: columns,
          spaceBetween: 16
        }
      }
    });
  }
}

customElements.define('featured-blog', FeaturedBlog);

class CountDownSlide extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    initSwiper(() => {
      this.init();
    });
  }

  init() {
    const slider = this.querySelector('.pdp_img_slider');
    if (!slider) return;

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    const swatches = this.querySelectorAll(
      '.variant-option__buttons .variant-swatch'
    );

    const variantImages = this.querySelectorAll(
      '.product_variant_image'
    );

    this.swiper = new Swiper(slider, {
      spaceBetween: 10,
      effect: 'fade',
      speed: 800,

      on: {
        init: () => {
          this.syncUI(0);
        },

        slideChange: () => {
          const index = this.swiper.activeIndex;
          this.syncUI(index);
        }
      }
    });

    /* --------------------------
       SWATCH CLICK
    -------------------------- */

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {

        const index = Number(swatch.dataset.slide);
        if (isNaN(index)) return;

        this.swiper.slideTo(index);
      });
    });

    /* store references */
    this.swatches = swatches;
    this.variantImages = variantImages;
  }

  /* --------------------------
     SYNC SWATCH + IMAGE
  -------------------------- */

  syncUI(index) {

    if (!this.swatches) return;

    this.swatches.forEach((swatch) => {
      swatch.classList.toggle(
        'is-active',
        Number(swatch.dataset.slide) === index
      );
    });

    this.variantImages.forEach((img) => {
      img.classList.toggle(
        'is-active',
        Number(img.dataset.variantIndex) === index
      );
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }
}

customElements.define('count-dwon-slide', CountDownSlide);

class BeforeAfterScroll extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll(".after_before_image_tab button");
    this.slides = this.querySelectorAll(".after_before_images");
    this.scrollerImgs = this.querySelectorAll(".scroller_img_visible");
    this.outer = this.querySelector(".after_before-outer");

    this.initTabs();
    this.initScroll();
  }

  initTabs() {
    if (!this.tabs.length) return;

    this.tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        const target = tab.dataset.target;

        // active tab
        this.tabs.forEach(t => t.classList.remove("active"));
        tab.classList.add("active");

        // active slide
        this.slides.forEach(slide => {
          slide.classList.toggle(
            "active",
            slide.dataset.slide === target
          );
        });

        // active product image
        this.scrollerImgs.forEach(img => {
          img.classList.toggle(
            "hidden",
            img.dataset.target !== target
          );
        });
      });
    });
  }

  initScroll() {
    if (!this.outer) return;

    window.addEventListener("scroll", () => {
      const activeSlide = this.querySelector(".after_before_images.active");
      if (!activeSlide) return;

      const product = activeSlide.querySelector("[data-product-img]");
      if (!product) return;

      const rect = this.outer.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      if (rect.top <= 0 && rect.bottom >= viewportHeight) {
        const progress = Math.abs(rect.top) / (rect.height - viewportHeight);
        const clamped = Math.min(Math.max(progress, 0), 1);

        const translateY = 500 - clamped * 500;
        product.style.transform = `translateY(${translateY}px)`;
      }
    });
  }
}

customElements.define("before-after-scroll", BeforeAfterScroll);

  class MediaGallery extends HTMLElement {
  constructor() {
    super();
    this.videos = [];
    this.iframes = [];
    this.cleanupResize = null;
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.mainSlider = this.querySelector(".main_media_slider_wrapper");
    this.thumbSlider = this.querySelector(".thumbnail_media_slider_wrapper");
    this.galleryWrapper = this;

    if (!this.mainSlider || !this.thumbSlider) return;

    window.initSwiper(() => this.init());
  }

  init() {
    if (this.swiper || this.thumbsSwiper) return;

    this.isVertical = this.hasAttribute("vertical") &&
                  this.getAttribute("vertical") !== "false";


    this.thumbsSwiper = new Swiper(this.thumbSlider, {
      direction: this.isVertical ? "vertical" : "horizontal",
      slidesPerView: this.isVertical ? 4 : 5,
      spaceBetween: 15,
      watchSlidesProgress: true,
      navigation: {
        nextEl: this.thumbSlider.querySelector(".swiper-button-next"),
        prevEl: this.thumbSlider.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        0: {
          slidesPerView: 4,
          direction: "horizontal",
        },
        900: {
          slidesPerView: this.isVertical ? 4 : 5,
          direction: this.isVertical ? "vertical" : "horizontal",
        },
      },
    });

    this.swiper = new Swiper(this.mainSlider, {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 800,
      autoHeight: true,
      allowTouchMove: false,
      simulateTouch: false,
      navigation: {
        nextEl: this.mainSlider.querySelector(".swiper-button-next"),
        prevEl: this.mainSlider.querySelector(".swiper-button-prev"),
      },
      thumbs: { swiper: this.thumbsSwiper },
      on: {
        slideChange: () => this.pauseAllMedia(),
      },
    });

    this.collectMedia();
    this.bindMediaHandlers();
    this.setupThumbnailClick();
    this.observeHeight();

    this.dispatchEvent(
      new CustomEvent("media-slider-ready", { detail: this.swiper })
    );
  }

  collectMedia() {
    this.videos = [...this.querySelectorAll("video")];
    this.iframes = [
      ...this.querySelectorAll(
        "iframe[src*='youtube'], iframe[src*='vimeo']"
      ),
    ];
  }

  pauseAllMedia(except = null) {
    this.videos.forEach(v => v !== except && v.pause());

    this.iframes.forEach(iframe => {
      if (iframe === except) return;
      iframe.contentWindow?.postMessage(
        iframe.src.includes("youtube")
          ? JSON.stringify({ event: "command", func: "pauseVideo", args: [] })
          : JSON.stringify({ method: "pause" }),
        "*"
      );
    });

    this.querySelectorAll("product-model").forEach(model => {
      if (model !== except && model.modelViewerUI) {
        model.modelViewerUI.pause();
      }
    });
  }
  slideToMediaPosition(position) {
  if (!this.swiper || !position) return;

  const slides = [
    ...this.querySelectorAll(
      ".main_media_slider_wrapper .product_media_wrapper"
    ),
  ];

  const index = slides.findIndex(
    slide => slide.dataset.position == position
  );

  if (index === -1) return;

  this.pauseAllMedia();
  this.swiper.slideTo(index); 
  this.thumbsSwiper?.slideTo(index); 
}

  bindMediaHandlers() { 
    this.videos.forEach(video => { 
      const wrapper = video.closest(".media_video_wrapper");
      const overlay = wrapper?.querySelector(".video_overlay");
      const btn = wrapper?.querySelector(".icon_wrapper");

      const play = e => {
        e.preventDefault();
        e.stopPropagation();
        this.pauseAllMedia();
        video.play();
      };

      overlay?.addEventListener("click", play);
      btn?.addEventListener("click", play);

      video.addEventListener("play", () => {
        btn && (btn.style.display = "none");
        overlay && (overlay.style.display = "none");
      });

      video.addEventListener("pause", () => {
        btn && (btn.style.display = "flex");
        overlay && (overlay.style.display = "block");
      });
    });
  }

  setupThumbnailClick() {
    this.querySelectorAll(
      ".thumbnail_media_slider_wrapper .swiper-slide"
    ).forEach(slide => {
      slide.addEventListener("click", () => {
        const pos =
          slide.querySelector(".product_media_wrapper")?.dataset.position;
        if (!pos) return;

        const slides = [
          ...this.querySelectorAll(
            ".main_media_slider_wrapper .product_media_wrapper"
          ),
        ];

        const index = slides.findIndex(
          s => s.dataset.position === pos
        );

        if (index !== -1) {
          this.pauseAllMedia();
          this.swiper.slideTo(index);
        }
      });
    });
  }

  
  observeHeight() {
  if (!this.isVertical) return;

  const wrapper = this.mainSlider?.querySelector(".swiper-wrapper");
  if (!wrapper) return;

  const updateFromStyle = () => {
    const height = wrapper.style.height;
    if (!height) return;

    this.style.setProperty("--vertical-match", height);
  };

  requestAnimationFrame(updateFromStyle);

  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type === "attributes" && mutation.attributeName === "style") {
        updateFromStyle();
      }
    }
  });

  observer.observe(wrapper, {
    attributes: true,
    attributeFilter: ["style"]
  });

  this.cleanupResize = () => observer.disconnect();
}


  disconnectedCallback() {
    this.cleanupResize?.();
    this.swiper?.destroy(true, true);
    this.thumbsSwiper?.destroy(true, true);
    this.swiper = null;
    this.thumbsSwiper = null;
    this._initialized = false;
  }
}

customElements.define("media-gallery", MediaGallery);


(function() {

  function initScrollAnimations() {

    const elements = document.querySelectorAll('[data-left], [data-right]');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            observer.unobserve(entry.target);
        } 
      });
    }, {
      threshold: 0.2
    });

    elements.forEach(el => observer.observe(el));
  }

  document.addEventListener('DOMContentLoaded', initScrollAnimations);

  document.addEventListener('shopify:section:load', initScrollAnimations);

})();

class ProductSection extends HTMLElement {
  constructor() {
    super();
    // Do not read dataset here: for elements created via innerHTML, attributes
    // are not guaranteed before the constructor runs (see custom elements docs).
    this.sectionId = undefined;
    this.productUrl = undefined;
    this.isMainProduct = undefined;
  }

  syncDatasetFields() {
    this.sectionId = this.dataset.sectionId;
    this.productUrl = this.dataset.productUrl;
    this.isMainProduct = this.dataset.mainProduct;
  }

  connectedCallback() {
    this.syncDatasetFields();

    if (this._productSectionListenersAttached) return;
    this._productSectionListenersAttached = true;

    this._onVariantChange = this.onVariantChange.bind(this);
    this._onQuantityChange = this.onQuantityChange.bind(this);
    this.addEventListener('variant-change', this._onVariantChange);
    this.addEventListener('quantity-change', this._onQuantityChange);
  }

  onQuantityChange(e) {
    const input = this.querySelector('input[name="quantity"]');
    if (input) input.value = e.detail.value;
  }

  onVariantChange(e) {
    const selectedOptions = e.detail.selectedOptions;
    const url = this.buildURL(selectedOptions);
    this.loadInfo(url);
  }

  buildURL(options) {
    this.syncDatasetFields();

    const originalSectionId =
      this.dataset.originalSectionId ||
      this.dataset.sectionId ||
      this.sectionId;

    const q = new URLSearchParams();
    if (this.isMainProduct !== 'true') {
      q.set('section_id', originalSectionId);
    }
    if (options.length) {
      q.set('option_values', options.join(','));
    }
    const qs = q.toString();
    return qs ? `${this.productUrl}?${qs}` : `${this.productUrl}`;
  }

  loadInfo(url) {
    fetch(url)
      .then(res => res.text())
      .then(htmlString => {
        const html = new DOMParser().parseFromString(htmlString, 'text/html');
        this.updateContent(html);
      });
  }

  updateContent(html) {
    this.syncDatasetFields();

    const sectionId = this.dataset.sectionId || this.sectionId;
    const originalSectionId =
      this.dataset.originalSectionId || sectionId;

    const elByDocId = (doc, id) => (id && doc.getElementById(id)) || null;

    const oldElInThis = (id) => {
      if (!sectionId) return null;
      const el = elByDocId(this.ownerDocument, `${id}-${sectionId}`);
      return el && this.contains(el) ? el : null;
    };

    const rewriteClonedSectionIds = (root) => {
      if (
        !root ||
        !originalSectionId ||
        !sectionId ||
        originalSectionId === sectionId
      ) {
        return;
      }
      const walk = (el) => {
        if (el.nodeType !== 1) return;
        for (const attr of [...el.attributes]) {
          if (attr.value.includes(originalSectionId)) {
            el.setAttribute(
              attr.name,
              attr.value.replaceAll(originalSectionId, sectionId)
            );
          }
        }
        for (const c of el.children) walk(c);
      };
      walk(root);
    };

    const oldWrapperInThis = (prefix) => {
      return (
        oldElInThis(prefix) ||
        (originalSectionId !== sectionId
          ? (() => {
              const el = elByDocId(
                this.ownerDocument,
                `${prefix}-${originalSectionId}`
              );
              return el && this.contains(el) ? el : null;
            })()
          : null)
      );
    };

    const update = (id) => {
      const oldEl = oldElInThis(id);
      const newEl = elByDocId(html, `${id}-${originalSectionId}`);

      if (oldEl && newEl) {
        oldEl.innerHTML = newEl.innerHTML;
      }
    };

    update('Price');
    update('SKU');
    update('Discount');
    update('Inventory');
    update('Pickup');

    const oldInventory = oldWrapperInThis('Inventory');
    const newInventory = elByDocId(html, `Inventory-${originalSectionId}`);

    if (oldInventory && newInventory) {
      const clone = newInventory.cloneNode(true);
      rewriteClonedSectionIds(clone);
      oldInventory.replaceWith(clone);
    }

    const oldVariant = oldWrapperInThis('variant_selector');
    const newVariant = elByDocId(html, `variant_selector-${originalSectionId}`);

    if (oldVariant && newVariant) {
      const clone = newVariant.cloneNode(true);
      rewriteClonedSectionIds(clone);
      oldVariant.replaceWith(clone);
    }

    const oldQty = oldWrapperInThis('Quantity');
    const newQty = elByDocId(html, `Quantity-${originalSectionId}`);

    if (oldQty && newQty) {
      const clone = newQty.cloneNode(true);
      rewriteClonedSectionIds(clone);
      oldQty.replaceWith(clone);
    }

    const oldJSON = this.querySelector('[data-selected-variant]');
    const newJSON = html.querySelector('[data-selected-variant]');

    if (oldJSON && newJSON) {
      oldJSON.textContent = newJSON.textContent;
    }

    // Add to cart button
    const oldBtn = this.querySelector('add-to-cart-form');
    const newBtn = html.querySelector('add-to-cart-form');

    if (oldBtn && newBtn) {
      const clone = newBtn.cloneNode(true);
      rewriteClonedSectionIds(clone);
      oldBtn.replaceWith(clone);
    }

    //  IMPORTANT: URL update logic (RESTORED)
    const isInsideDrawer = this.closest('.qv-dialog');

    if (
      this.dataset.updateUrl === 'true' &&
      !isInsideDrawer
    ) {
      this.updateURL(html);
    }

    this.setMainInput(html);

    const variant = this.extractVariantData(html);

    if (variant?.featured_media?.position) {
      const gallery = this.querySelector('media-gallery');
      if (gallery?.slideToMediaPosition) {
        gallery.slideToMediaPosition(variant.featured_media.position);
      }
    }
  }

  extractVariantData(html) {
    const el = html.querySelector('[data-selected-variant]');
    return el ? JSON.parse(el.textContent) : null;
  }

  updateURL(html) {
    const variant = this.extractVariantData(html);
    if (!variant) return;

    window.history.replaceState(null, '', `${this.productUrl}?variant=${variant.id}`);
  }

  setMainInput(html) {
    const variant = this.extractVariantData(html);
    if (!variant) return;

    const input = this.querySelector('input[name="id"]');
    if (input) input.value = variant.id;
  }
}

customElements.define('product-section', ProductSection);

class VariantSelector extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    this.addEventListener('change', (e) => {
      this.selectedOptions = this.getSelectedOptions;
      
      this.dispatchEvent(
        new CustomEvent('variant-change', {
          detail: {
            selectedOptions: this.selectedOptions
          },
          bubbles: true
        })
      )
    })
  }

  get getSelectedOptions() {
      const selectValues = Array.from(this.querySelectorAll('select')).map((select) => {
        return select.selectedOptions[0].dataset.value;
      })

      const radioValues = Array.from(this.querySelectorAll('input[type="radio"]:checked')).map((input) => {
        return input.dataset.value;
      })

      return [...selectValues, ...radioValues];
  }
}

customElements.define('variant-selector', VariantSelector);


class productQuantity extends HTMLElement {
  constructor() {
    super();
    this.minusBtn = this.querySelector('[data-minus]');
    this.input = this.querySelector('input[type="text"]');
    this.plusBtn = this.querySelector('[data-plus]');
    this.value = Number(this.input.value); 
    this.step = Number(this.input.getAttribute('step')) || 1;
    this.min = this.input.dataset.min || 1;
    this.max = this.input.dataset.max;
  }

  connectedCallback() {
    this.minusBtn.addEventListener('click', this.handleChange.bind(this));
    this.plusBtn.addEventListener('click', this.handleChange.bind(this));
    const debouncedInputandler = this._debounce((e) => this.handleInput(e), 1000)
    this.input.addEventListener('input', debouncedInputandler);
  }

  handleChange(e) {
    if(e.currentTarget.hasAttribute('data-plus')) {
      this.value = this.value + this.step;
      this.input.value = this.value;
    } else {
      this.value = this.value - this.step;
      this.input.value = this.value;
    }

    if(this.min) {
      if(this.value <= this.min) {
        this.minusBtn.setAttribute('disabled', '');
      } else {
        this.minusBtn.removeAttribute('disabled');
      }
    }
    
    if(this.max) {
      if(this.value >= this.max) {
        this.plusBtn.setAttribute('disabled', '');
      } else {
        this.plusBtn.removeAttribute('disabled');
      }
    }

    this.dispatchEvent(
      new CustomEvent('quantity-change', {
        detail: {
          value: this.value
        },
        bubbles: true
      })
    )    
  }

  handleInput(e) {
    this.value = Number(this.input.value);
    if(this.value == 0) {
      this.value = 1;
      this.input.value = 1;
    }

    if(this.min) {
      if(this.value <= this.min) {
        this.minusBtn.setAttribute('disabled', '');
      } else {
        this.minusBtn.removeAttribute('disabled');
      }
    }

    if(this.max) {
      if(this.value >= this.max) {
        this.plusBtn.setAttribute('disabled', '');
      } else {
        this.plusBtn.removeAttribute('disabled');
      }
    }

    this.dispatchEvent(
      new CustomEvent('quantity-change', {
        detail: {
          value: this.value
        },
        bubbles: true
      })
    ) 

  }

  _debounce(fn, wait = 1000) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('product-quantity', productQuantity);

const elements = document.querySelectorAll('.section-animate');
   
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => { 
    if (entry.intersectionRatio >= 0.4) { 
      entry.target.classList.add('loaded');
      observer.unobserve(entry.target); 
    }
  });
}, {
  threshold: 0.4
});

elements.forEach(el => {
  observer.observe(el);

  // check immediately on load
  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight;

  if (rect.top < windowHeight * 0.4) {
    el.classList.add('loaded');
    observer.unobserve(el);
  }
});


class Scrollexpose {
    constructor(selector = ".expose", delayDelay = 300) {
        this.selector = selector, this.delayDelay = delayDelay, this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
            root: null,
            threshold: .2
        }), this.initElements()
    }
    initElements(scope = document) {
        scope.querySelectorAll(this.selector).forEach(el => {
            el.dataset.exposeed !== "true" && (el.style.opacity = 0, el.style.transform = "translateY(20px)", el.style.transition = "all 0.4s ease", this.observer.observe(el))
        })
    }
    delayBatch(elements) {
        elements.forEach((el, index) => {
            setTimeout(() => {
                el.style.opacity = 1, el.style.transform = "translateY(0)", el.dataset.exposeed = "true"
            }, index * this.delayDelay), this.observer.unobserve(el)
        })
    }
    onIntersect(entries, observer) {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const el = entry.target;
            if (el.classList.contains("delay")) { 
                const siblings = Array.from(el.parentNode.querySelectorAll(".expose.delay")).filter(sib => sib.dataset.exposeed !== "true");
                this.delayBatch(siblings)
            } else el.style.opacity = 1, el.style.transform = "translateY(0)", el.dataset.exposeed = "true", observer.unobserve(el)
        })
    }
}
let scrollexpose;
document.addEventListener("DOMContentLoaded", () => {
    scrollexpose = new Scrollexpose(".expose", 150)
}), document.addEventListener("shopify:section:load", () => {
    scrollexpose = new Scrollexpose(".expose", 150)
});

function debounce(fn, delay) {
    let timer;
    return (...args) => {
        clearTimeout(timer), timer = setTimeout(() => fn.apply(this, args), delay)
    }
}


function heroViewedObserver() {
  const hero = document.querySelector('.hero_banner_wrapper');
  if (!hero) return;

  const nextSection = hero.nextElementSibling;
  if (!nextSection) return;

  function checkHero() {
    const nextTop = nextSection.getBoundingClientRect().top;

    if (nextTop <= 0) {
      hero.classList.add('viewed');
    } else {
      hero.classList.remove('viewed');
    }
  }

  window.addEventListener('scroll', checkHero);
  checkHero();
}

document.addEventListener('DOMContentLoaded', heroViewedObserver);
document.addEventListener('shopify:section:load', heroViewedObserver);


const openBtns = document.querySelectorAll(".drawer_open_btn");
const closeBtns = document.querySelectorAll(".drawer_close_btn");
const drawers = document.querySelectorAll(".drawer-wrapper");

let lastFocusedButton = null;

drawers.forEach((drawer) => {
  const focusableElements = drawer.querySelectorAll("button, input:not([type='hidden']), a, select, textarea");
  focusableElements.forEach((el) => {
    el.setAttribute("tabindex", "-1");
  });
});

/* -----------------------------
  CLOSE ALL (updated with animation)
------------------------------ */
function closeAllDrawers() {
  drawers.forEach((drawer) => {
    if (drawer.classList.contains("active")) {
      closeDrawer(drawer);
    }
  });
}

/* -----------------------------
  FOCUS TRAP
------------------------------ */
function trapFocus(event, drawer) {
  const focusableElements = drawer.querySelectorAll("button, input:not([type='hidden']), a, select, textarea");
  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  if (event.key === "Tab") {
    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }
}

function openDrawer(drawer, button) {
  closeAllDrawers();

  if (drawer) {
    lastFocusedButton = button;

    drawer.classList.remove("closing"); // ensure reset
    drawer.classList.add("active", "drawer-pannel");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("overflow-hidden");

    if (drawer.hasAttribute('inert')) {
      drawer.removeAttribute('inert');
    }

    const focusableElements = drawer.querySelectorAll("button, input:not([type='hidden']), a, select, textarea");
    focusableElements.forEach((el) => {
      el.setAttribute("tabindex", "0");
    });

    const autofocusEl = drawer.querySelector('[data-autofocus]');
    if (autofocusEl) {
      autofocusEl.focus();
    } else if (focusableElements.length) {
      focusableElements[0].focus();
    }

    window.whenLenisReady(lenis => {
      lenis.stop();
    });

    drawer.addEventListener("keydown", (event) => trapFocus(event, drawer));
  }
}

function closeDrawer(drawer) {
  if (!drawer || !drawer.classList.contains("active")) return;

  drawer.classList.add("closing");

  setTimeout(() => {
    drawer.classList.remove("active", "drawer-pannel", "content_fetched", "closing");
    drawer.setAttribute("aria-hidden", "true");
    drawer.setAttribute('inert', '');
    document.body.classList.remove("overflow-hidden");

    if (drawer.classList.contains("mobile_filter_drawer_wrapper")) {
      setTimeout(() => {
        document.querySelector(".header_block").style.zIndex = "4";
      }, 200);
    } 
    else if (drawer.classList.contains('quick-view-wrapper')) {
      const placeholderTemplate = document.getElementById('quick-view-drawer_placeholder_template');
      const contentWrapper = drawer.querySelector('.quick-view-main-inner');

      if (placeholderTemplate && contentWrapper) {
        contentWrapper.innerHTML = placeholderTemplate.innerHTML;
      }
    }

    const focusableElements = drawer.querySelectorAll("input, button, a");
    focusableElements.forEach((el) => {
      el.setAttribute("tabindex", "-1");
    });

    if (lastFocusedButton) {
      lastFocusedButton.focus();
      lastFocusedButton = null;
    }

    window.whenLenisReady(lenis => {
      lenis.start();
    });

  }, 350); 
}

/* -----------------------------
  INIT OPEN BUTTONS
------------------------------ */
function initDrawerOpenButtons() {
  const openBtns = document.querySelectorAll('[data-drawer]');

  openBtns.forEach((button) => {
    if (!button.hasAttribute('data-drawer-initialized')) {
      button.setAttribute('data-drawer-initialized', 'true');

      button.addEventListener("click", async (event) => {
        event.preventDefault();
        const drawerId = button.getAttribute("data-drawer");
        const drawer = document.getElementById(drawerId);

        if (drawer) {
          openDrawer(drawer, button);
        }
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", initDrawerOpenButtons);
document.addEventListener("shopify:section:load", initDrawerOpenButtons);
document.addEventListener("shopify:section:unload", initDrawerOpenButtons);
  
function bindDrawerCloseButtons() {  
  document.querySelectorAll('.drawer_close_btn').forEach((button) => {
    if (button.dataset.closeInitialized) return; // avoid rebinding
    button.dataset.closeInitialized = "true";

    button.addEventListener("click", () => {
      const drawer = button.closest(".drawer-wrapper");
      drawer.classList.add('closing');
      closeDrawer(drawer); 
    });
  });
}

document.addEventListener("DOMContentLoaded", bindDrawerCloseButtons);
document.addEventListener("shopify:section:load", bindDrawerCloseButtons);


drawers.forEach((drawer) => {  
  drawer.addEventListener("click", (event) => { 
    if (event.target === drawer) { 
      closeDrawer(drawer);
    }
  });

  drawer.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeDrawer(drawer);
    }
  });

  const Inner = drawer.querySelector(".drawer-wrapper_inner");

});



class CartDrawerClose extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector('.drawer_close_btn');
    this.drawer = this.closest('.cart_drawer_wrapper');
  }
 
  connectedCallback() {
    this.closeBtn.addEventListener('click', this.handleClose.bind(this));
  }

  handleClose() {
    closeDrawer(this.drawer);
  }
}

customElements.define('cart-drawer-close', CartDrawerClose);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.loader = document.querySelector('.cart_drawer_wrapper .loader_wrapper');
  }

  connectedCallback() {
    document.addEventListener('cart-update', this.cartUpdate.bind(this));
  }

  cartUpdate(e) {
    // CART DRAWER UPDATE
    let tempDiv = document.createElement('div');
    let newDrawer = e.detail.sections['cart-drawer'];
    let error = e.detail.message;
    let button = e.detail.button;
    
    if(newDrawer) {
      tempDiv.innerHTML = newDrawer;
    }
    let cartDrawer = document.querySelector('.cart_drawer_inner');
    if(cartDrawer) {
      cartDrawer.innerHTML = tempDiv.querySelector('.cart_drawer_inner').innerHTML;  
      const newLoader = document.querySelector('.cart_drawer_wrapper .loader_wrapper');
      if (newLoader) {
        newLoader.classList.remove('active');
      }

      document.querySelectorAll('.cart_remove_btn').forEach(btn => {
        btn.classList.remove('disabled');
      });
        
      if(error && e.detail.line) {
        const lineWrapper = cartDrawer.querySelector(`quantity-wrapper[data-line="${e.detail.line}"]`);
        if(lineWrapper) {
          lineWrapper.querySelector('.cart_quantity_error').textContent = error;
          lineWrapper.querySelector('.cart_quantity_error').classList.remove('hidden');
        }        
      }
    }

      // CART COUNT UPDATE
      const newCount = e.detail.sections['cart-icon-bubble'];

      if (newCount) {
        const temp = document.createElement('div');
        temp.innerHTML = newCount;

        const newBubble = temp.querySelector('#cart-icon-bubble');

        if (newBubble) {
          document.querySelectorAll('#cart-icon-bubble').forEach((bubble) => {
            bubble.innerHTML = newBubble.innerHTML;
          });
        }
      }
    
    const drawer = document.querySelector('.cart_drawer_wrapper');
    const isCartPage = window.location.pathname.startsWith('/cart');

    if (drawer && button && !isCartPage) {    
      openDrawer(drawer, button);
    }    
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartRemove extends HTMLElement {
  constructor() {
    super();
    this.link = this.querySelector('a');
    this.line = this.dataset.line;
    this.wrapper = this.closest('cart-drawer') || this.closest('cart-main');
    this.loader = this.wrapper.querySelector?.('.loader_wrapper');
  }

  connectedCallback() {
    this.link.addEventListener('click', this.handleRemove.bind(this));
  }

  handleRemove(e) {
    e.preventDefault();
    if(this.loader) {
      this.loader.classList.add('active');
    }

    this.link.classList.add('disabled');

    const formData = {
      'line': this.line,
      'quantity': e.currentTarget.dataset.quantity,
      'sections': 'cart-drawer,cart-icon-bubble,cart'
    }

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((res) => res.json())
    .then((data) => {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart-update', {
          detail: data,
          bubbles: true
        })
      )
    })
  }
}

customElements.define('cart-remove', CartRemove);


class CartMain extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener('cart-update', this.handleCartPageUpdate.bind(this));
  }
   
  handleCartPageUpdate(e) {

    const tempCart = document.createElement('div');
    const newCart = e.detail.sections['cart'];
    let error = e.detail.message;
   
    if(newCart) {
      tempCart.innerHTML = newCart;
    }

    const oldCart = document.querySelector('cart-main');
    if(oldCart) {  
      oldCart.querySelector('.cart_main_inner').innerHTML = tempCart.querySelector('.cart_main_inner').innerHTML;
      if(error && e.detail.line) {   
        const lineWrapper = oldCart.querySelector(`quantity-wrapper[data-line="${e.detail.line}"]`);
        if(lineWrapper) {  
          lineWrapper.querySelector('.cart_quantity_error').textContent = error;
          lineWrapper.querySelector('.cart_quantity_error').classList.remove('hidden');
        }         
      }
    }

    let temp = document.createElement('div');
    let newCount = e.detail.sections['cart-icon-bubble'];
    if(newCount) {
      temp.innerHTML = newCount;
    }

    document.querySelector('.cc_text').innerHTML = temp.querySelector('.cc_text').innerHTML;     
  }
}

customElements.define('cart-main', CartMain);

// class QuantityWrapper extends HTMLElement {
//   constructor() {
//     super();
//     this.minusBtn = this.querySelector('[data-minus]');
//     this.plusBtn = this.querySelector('[data-plus]');
//     this.input = this.querySelector('input');   
//     this.line = this.dataset.line; 
//     this.wrapper = this.closest('cart-drawer') || this.closest('cart-main');
//     this.loader = this.wrapper.querySelector('.loader_wrapper');
//   }

//   connectedCallback() {
//     this.plusBtn.addEventListener('click', this.handleChange.bind(this));
//     this.minusBtn.addEventListener('click', this.handleChange.bind(this));
//     const debouncedHandler = this._debounce((e) => this.handleInput(e), 1000)
//     this.input.addEventListener('input', debouncedHandler);
//   }

//   getLoader() {
//     return document.querySelector('.cart_drawer_wrapper .loader_wrapper');
//   }

//   toggleLoader(show = true) {
//     const loader = this.getLoader();
//     if (!loader) return;
//     loader.classList.toggle('active', show);
//   } 

//   getValue(e) {
//     if(e.currentTarget.hasAttribute('data-plus')) {
//       let value = parseInt(this.input.value);
//       value = value + 1;
//       if(value == 1) {
//         this.minusBtn.setAttribute('disabled', '');
//       } else {
//         this.minusBtn.removeAttribute('disabled');
//       }

//       this.input.value = value;
//       return value;
//     } else {
//       let value = parseInt(this.input.value);
//       value = value - 1;
//       if(value == 1) {
//         this.minusBtn.setAttribute('disabled', '');
//       } else {
//         this.minusBtn.removeAttribute('disabled');
//       }

//       this.input.value = value;
//       return value;
//     }
//   }

//   handleChange(e) {
//     e.preventDefault();
//     let value = this.getValue(e);
    
//     if(this.loader) {
//       this.loader.classList.add('active');
//     }

//     const formData = {
//       'line': this.line,
//       'quantity': value,
//       'sections': 'cart-drawer,cart-icon-bubble,cart'
//     }

//     fetch(window.Shopify.routes.root + 'cart/change.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(formData)
//     })
//     .then(async (res) => {
//       const data = await res.json();

//       if(!res.ok) {        
//         const rawCartData = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble,cart').then((res) => res.json());        
//         const cartData = {
//           'line': this.line,
//           'message': data.message || data.description,
//           'sections': rawCartData,          
//         }

//         document.dispatchEvent(
//           new CustomEvent('cart-update', {
//             detail: cartData,
//             bubbles: true
//           })
//         )
//         throw new Error(data.description || data.message || 'Request failed');        
//       }

//       return data;
//     })
//     .then((cartData) => {          
//       document.documentElement.dispatchEvent(
//         new CustomEvent('cart-update', {
//           detail: cartData,          
//           bubbles: true
//         })
//       )
//     })
//   }

//   handleInput(e) {
//     e.preventDefault();

//     if(this.loader) {
//       this.loader.classList.add('active');
//     }

//     const formData = {
//       'line': this.line,
//       'quantity': e.target.value,
//       'sections': 'cart-drawer,cart-icon-bubble,cart'
//     }

//     fetch(window.Shopify.routes.root + 'cart/change.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(formData)
//     })
//     .then(async (res) => {
//       const data = await res.json();

//       if(!res.ok) {        
//         const rawCartData = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble,cart').then((res) => res.json());        
//         const cartData = {
//           'line': this.line,
//           'message': data.message || data.description,
//           'sections': rawCartData
//         }

//         document.dispatchEvent(
//           new CustomEvent('cart-update', {
//             detail: cartData,
//             bubbles: true
//           })
//         )
//         throw new Error(data.description || data.message || 'Request failed');        
//       }

//       return data;
//     })
//     .then((cartData) => {
//       document.documentElement.dispatchEvent(
//         new CustomEvent('cart-update', {
//           detail: cartData,
//           bubbles: true
//         })
//       ) 
//     })
//   }

//   _debounce(fn, wait = 1000) {
//     let t;
//     return (...args) => {
//       clearTimeout(t);
//       t = setTimeout(() => fn.apply(this, args), wait);
//     };
//   }
// }

// customElements.define('quantity-wrapper', QuantityWrapper);

class QuantityWrapper extends HTMLElement {
  constructor() {
    super();
    this.minusBtn = this.querySelector('[data-minus]');
    this.plusBtn = this.querySelector('[data-plus]');
    this.input = this.querySelector('input');   
    this.line = this.dataset.line; 
  }

  connectedCallback() {
    this.plusBtn?.addEventListener('click', this.handleClick.bind(this));
    this.minusBtn?.addEventListener('click', this.handleClick.bind(this));

    const debouncedHandler = this._debounce((e) => this.handleInput(e), 600);
    this.input?.addEventListener('input', debouncedHandler);
  }

  getLoader() {
    // ✅ Always fetch fresh loader (important)
    return document.querySelector('.cart_drawer_wrapper .loader_wrapper');
  }

  toggleLoader(show = true) {
    const loader = this.getLoader();
    if (!loader) return;
    loader.classList.toggle('active', show);
  }

  getValue(e) {
    let value = parseInt(this.input.value) || 1;

    if (e.currentTarget.hasAttribute('data-plus')) {
      value += 1;
    } else {
      value = Math.max(1, value - 1);
    }

    this.input.value = value;
    this.updateButtons(value);

    return value;
  }

  updateButtons(value) {
    if (value <= 1) {
      this.minusBtn?.setAttribute('disabled', '');
    } else {
      this.minusBtn?.removeAttribute('disabled');
    }
  }

  handleClick(e) {
    e.preventDefault();
    const value = this.getValue(e);
    this.updateCart(value);
  }

  handleInput(e) {
    let value = parseInt(e.target.value);

    // ✅ Validate input
    if (isNaN(value) || value < 1) {
      value = 1;
    }

    this.input.value = value;
    this.updateButtons(value);
    this.updateCart(value);
  }

  updateCart(value) {
    this.toggleLoader(true);

    const formData = {
      line: this.line,
      quantity: value,
      sections: 'cart-drawer,cart-icon-bubble,cart'
    };

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(async (res) => {
      const data = await res.json();

      if (!res.ok) {
        const rawSections = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble,cart')
          .then(r => r.json());

        throw {
          line: this.line,
          message: data.message || data.description,
          sections: rawSections
        };
      }

      return data;
    })
    .then((data) => {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart-update', {
          detail: data,
          bubbles: true
        })
      );
    })
    .catch((errorData) => {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart-update', {
          detail: errorData,
          bubbles: true
        })
      );
    })
    .finally(() => {
      setTimeout(() => {
        this.toggleLoader(false);
      }, 200);
    });
  }

  _debounce(fn, wait = 600) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('quantity-wrapper', QuantityWrapper);
 

class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="discount"]');
        this.inputValue = this.input.value;
        this.remove = this.querySelector('[data-discount-remove]');
        this.error = this.querySelector('.cart_discount_error');
        this.wrapper = this.closest('cart-drawer') || this.closest('cart-main');
        this.loader = this.wrapper.querySelector('.loader_wrapper');
  }

  connectedCallback() {
        this.input.addEventListener('input', this.handleInput.bind(this));
        this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
        if(this.remove) {
            this.remove.addEventListener('click', this.handleRemove.bind(this));
        }
    }

    handleInput(e) {
        e.preventDefault();
        this.inputValue = this.input.value;
    }

    handleFormSubmit(e) {
      e.preventDefault();

      if(this.loader) {
        this.loader.classList.add('active');
      }

      const formData = {
        discount: this.inputValue,
        sections: 'cart-drawer,cart-icon-bubble,cart'
      }

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': "application/json"
        },
        body: JSON.stringify(formData)
      })
      .then((res) => res.json())
      .then((cartData) => {
        if(cartData.discount_codes[0].applicable == false) {
          if(this.error) {
            this.error.classList.remove('hidden');
            this.input.value = "";
          } 

          if(this.loader) {
           this.loader.classList.remove('active');
          }
        } else {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart-update', {
              detail: cartData,
              bubbles: true
            })
          )
        }
      })
    }

    handleRemove(e) {
      e.preventDefault();

      if(this.loader) {
        this.loader.classList.add('active');      
      }  

      const formData = {
        discount: "",
        sections: "cart-drawer,cart-icon-bubble,cart"
      }

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': "application/json",
        },
        body: JSON.stringify(formData)
      })
      .then((res) => res.json())
      .then((cartData) => {
        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: cartData,
            bubbles: true
          })
        )
      })
    }
}

customElements.define('discount-field', CartDiscount);

class ProductForm extends HTMLElement {
  constructor() {  
    super();
    this.form = this.querySelector('form.product_form');
    this.button = this.querySelector('.add_to_cart_button');
    this.icon = this.button.querySelector('.icon_wrapper') || this.button.querySelector('.atc_text');
    this.mainInput = this.querySelector('input[name="id"]');
    this.cart = document.querySelector('cart-drawer');
    this.loader = this.button.querySelector('.form_loader');
    this.info = this.closest('product-section');

    this.isSubmitting = false;

    if (this.info) {
      this.giftWrap = this.info.querySelector('#product_gift_wrapp');
    }
  }

  connectedCallback() {
    if (this._initialized) return; 
    this._initialized = true;

    this.handleSubmit = this.handleFormSubmit.bind(this);
    this.form.addEventListener('submit', this.handleSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.handleSubmit);
    this._initialized = false;
  }

  handleFormSubmit(e) {
    e.preventDefault();

    // prevent duplicate calls
    if (this.isSubmitting) return;
    this.isSubmitting = true;

    // UI state
    this.icon.classList.add('hidden');
    if (this.loader) {
      this.loader.classList.remove('hidden');
    }

    this.button.setAttribute('disabled', 'true'); // block clicks

    const formData = new FormData(this.form);
    const payload = {};

    for (const [key, value] of formData.entries()) {
      const propertyMatch = key.match(/^properties\[(.+)\]$/);

      if (propertyMatch) {
        if (!payload.properties) payload.properties = {};
        payload.properties[propertyMatch[1]] = value;
      } else {
        payload[key] = value;
      }
    }

    const items = [payload];

    if (this.giftWrap && this.giftWrap.checked) {
      const giftWrapId = this.giftWrap.value;

      items.push({
        id: giftWrapId,
        quantity: 1,
        parent_id: this.mainInput.value,
        properties: {
          for: `${this.mainInput.dataset.title} (${this.mainInput.dataset.variantTitle})`
        }
      });
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items })
    })
    .then(async (res) => {
      const data = await res.json();

      if (!res.ok) {
        let message = '';

        if (data.errors) {
          Object.entries(data.errors).forEach(([field, messages]) => {
            if (Object.keys(data.errors).length > 1) {
              message += `<div>${messages[0]}</div>`;
            } else {
              message = messages[0];
            }
          });
        } else if (data.description) {
          message = data.description;
        } else if (data.message) {
          message = data.message;
        }

        const errorWrapper = this.querySelector('.product_card_cart_error');
        const error = this.closest('product-info');

        if (errorWrapper) {
          errorWrapper.innerHTML = message;
          errorWrapper.classList.add('show');

          setTimeout(() => {
            errorWrapper.classList.remove('show');
          }, 2000);
        }

        if (error) {
          error.querySelector('.product_quantity_error').innerHTML = message;
          error.querySelector('.product_quantity_error').classList.remove('hidden');
        }

        const rawCartData = await fetch(
          window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble,cart'
        ).then((res) => res.json());

        const cartData = {
          sections: rawCartData,
          message: message,
        };

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: cartData,
            bubbles: true
          })
        );

        throw new Error(message);
      }

      return data;
    })
    .then(async () => {
      if (this.cart) {
        const rawCartData = await fetch(
          window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble,cart'
        ).then((res) => res.json());

        const cartData = {
          sections: rawCartData,
          button: this.button
        };

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: cartData,
            bubbles: true
          })
        );
      } else {
        window.location.href = window.Shopify.routes.root + 'cart';
      }
    })
    .finally(() => {
      //  reset state
      this.icon.classList.remove('hidden');
      this.loader.classList.add('hidden');

      this.button.removeAttribute('disabled');
      this.isSubmitting = false;
    });
  }
}

customElements.define('product-form', ProductForm);

class ProductAddForm extends HTMLElement {
  constructor() {  
    super();

    this.form = this.querySelector('form');
    this.button = this.querySelector('.product_form_submit_button');
    this.icon = this.button.querySelector('.icon_wrapper') || this.button.querySelector('.inner_btn');
    this.mainInput = this.querySelector('input[name="id"]');
    this.cart = document.querySelector('#shopify-section-cart-drawer cart-drawer');
    this.loader = this.button.querySelector('.form_loader');
    this.info = this.closest('product-section');

    this.isSubmitting = false; // prevent multiple submit

    if (this.info) {
      this.giftWrap = this.info.querySelector('#product_gift_wrapp');
    }
  }

  connectedCallback() {
    if (this._initialized) return; // prevent duplicate binding
    this._initialized = true;

    this.handleSubmit = this.handleFormSubmit.bind(this);
    this.form.addEventListener('submit', this.handleSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.handleSubmit);
    this._initialized = false;
  }

  handleFormSubmit(e) {
    e.preventDefault();

    // BLOCK duplicate submits
    if (this.isSubmitting) return;
    this.isSubmitting = true;

    // UI state
    this.icon.classList.add('hidden');
    this.loader?.classList.remove('hidden');
    this.button.setAttribute('disabled', 'true'); // disable button

    const formData = new FormData(this.form);
    const payload = {};

    for (const [key, value] of formData.entries()) {
      const propertyMatch = key.match(/^properties\[(.+)\]$/);

      if (propertyMatch) {
        if (!payload.properties) payload.properties = {};
        payload.properties[propertyMatch[1]] = value;
      } else {
        payload[key] = value;
      }
    }

    const items = [payload];

    if (this.giftWrap && this.giftWrap.checked) {
      const giftWrapId = this.giftWrap.value;

      items.push({
        id: giftWrapId,
        quantity: 1,
        parent_id: this.mainInput.value,
        properties: {
          for: `${this.mainInput.dataset.title} (${this.mainInput.dataset.variantTitle})`
        }
      });
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items })
    })
    .then(async (res) => {
      const data = await res.json();

      if (!res.ok) {
        let message = '';

        if (data.errors) {
          Object.entries(data.errors).forEach(([field, messages]) => {
            if (Object.keys(data.errors).length > 1) {
              message += `<div>${messages[0]}</div>`;
            } else {
              message = messages[0];
            }
          });
        } else if (data.description) {
          message = data.description;
        } else if (data.message) {
          message = data.message;
        }

        const errorWrapper = this.querySelector('.product_block_cart_error');
        const error = this.closest('product-info');

        if (errorWrapper) {
          errorWrapper.innerHTML = message;
          errorWrapper.classList.add('show');

          setTimeout(() => {
            errorWrapper.classList.remove('show');
          }, 8000);
        }

        if (error) {
          error.querySelector('.product_quantity_error').innerHTML = message;
          error.querySelector('.product_quantity_error').classList.remove('hidden');
        }

        const rawCartData = await fetch(
          window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble,cart'
        ).then((res) => res.json());

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: {
              sections: rawCartData,
              message: message
            },
            bubbles: true
          })
        );

        throw new Error(message);
      }

      return data;
    })
    .then(async () => {
      if (this.cart) {
        const rawCartData = await fetch(
          window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble,cart'
        ).then((res) => res.json());

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: {
              sections: rawCartData,
              button: this.button
            },
            bubbles: true
          })
        );

        const drawer = document.getElementById(this.cart.id);
        if (drawer && typeof drawer.open === 'function') {
          drawer.open(this.button);
        }

      } else {
        window.location.href = window.Shopify.routes.root + 'cart';
      }
    })
    .finally(() => {
      //  RESET STATE
      this.icon.classList.remove('hidden');
      this.loader?.classList.add('hidden');
      this.button.removeAttribute('disabled');
      this.isSubmitting = false;
    });
  }
}

customElements.define('add-to-cart-form', ProductAddForm);


class RecommendedProducts extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.sectionId = this.dataset.sectionId;
    this.recommendedURL = this.dataset.url;
    this.spacing = Number(this.dataset.spacing);
    this.columns = Number(this.dataset.columns);
    this.mobColumns = Number(this.dataset.mobColumns);
    this.tabColumns = Number(this.dataset.tabColumns);
    this.midColumns = Number(this.dataset.midColumns);
  }

  connectedCallback() {
    this.loadRecommendedProducts(
      this.recommendedURL,
      this.productId,
      this.sectionId
    );
  }

  loadRecommendedProducts(recommendedURL, productId, sectionId) {
    fetch(`${recommendedURL}&product_id=${productId}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((data) => {
        const html = document.createElement("div");
        html.innerHTML = data;

        const recommendedProducts = html.querySelector("recommended-products");

        if (recommendedProducts?.innerHTML.trim().length) {
          this.innerHTML = recommendedProducts.innerHTML;

          this.productsInner =
            this.querySelector(".featured_collection_inner") ||
            this.querySelector(".product-complementary-inner");

          this.initRecommendedSlider();
          document.dispatchEvent(new CustomEvent("RecommendedProductsUpdated"));
        }
      });
  } 

  initRecommendedSlider() {
  const inner = this.productsInner;
  const spacing = this.spacing;

  const prevBtn = this.querySelector('.swiper-button-prev'); 
  const nextBtn = this.querySelector('.swiper-button-next');

  new Swiper(inner, {
    slidesPerView: this.columns,
    spaceBetween: spacing,

    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    pagination: {
    el: this.querySelector('.swiper-pagination'),
    clickable: true,
  },
    breakpoints: {
      0: {
        slidesPerView: this.mobColumns,
        spaceBetween: spacing
      },
      640: {
        slidesPerView: this.columns,
        spaceBetween: spacing
      },
      768: {
        slidesPerView: this.tabColumns,
        spaceBetween: spacing
      },
      1280: {
        slidesPerView: this.midColumns,
        spaceBetween: spacing
      },
      1399: {
        slidesPerView: this.columns,
        spaceBetween: spacing
      }
    }
  });
}

}
if (!customElements.get('recommended-products')) {
customElements.define("recommended-products", RecommendedProducts);
}

(function() {

  function initScrollAnimations() {

    const elements = document.querySelectorAll('[data-left], [data-right]');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            observer.unobserve(entry.target);
        } 
      });
    }, {
      threshold: 0.2
    });

    elements.forEach(el => observer.observe(el));
  }

  document.addEventListener('DOMContentLoaded', initScrollAnimations);

  document.addEventListener('shopify:section:load', initScrollAnimations);

})();



if (!customElements.get("cart-note")) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.textarea = this.querySelector("textarea[name='note']");
      this.debounceTimer = null;
      this.debounceDelay = 500;
    }

    connectedCallback() {
      if (!this.textarea) return;

      this.textarea.addEventListener("input", this.handleInput.bind(this));
    }

    disconnectedCallback() {
      if (!this.textarea) return;
      this.textarea.removeEventListener("input", this.handleInput);
    }

    handleInput(e) {
      const value = e.target.value;

      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.updateCartNote(value, e);
      }, this.debounceDelay);
    }

    updateCartNote(note, event) {
      fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ note }),
      }).then(() => {
        if (window.CartPerformance?.measureFromEvent) {
          CartPerformance.measureFromEvent(
            "note-update:user-action",
            event
          );
        }
      });
    }
  }

  customElements.define("cart-note", CartNote);
}


class FilterDrawerClose extends HTMLElement {
  connectedCallback() {
    if (typeof bindDrawerCloseButtons === 'function') {
      bindDrawerCloseButtons();
    }
  } 
}

if (!customElements.get('drawer-close')) { 
  customElements.define('drawer-close', FilterDrawerClose);
}


